import { message as antMessage } from 'antd';
import { onNextDetailPanelReady } from 'components/RecordsListView/DetailPanel/detailPanelReady';

type BannerConfig = Parameters<typeof antMessage.success>[0];

/**
 * Show a record banner once the destination's detail panel is on screen.
 *
 * The banner is anchored to that panel's box, so showing it at click time
 * renders it window-centred for a frame and then snaps into place. This waits
 * for the panel's own mount rather than a timer, so a slow details fetch just
 * delays the banner instead of showing it in the wrong position.
 */
const showRecordBanner = (config: BannerConfig) => {
  onNextDetailPanelReady(() => antMessage.success(config));
};

export default showRecordBanner;
